module.exports = __webpack_public_path__ + "img/logo.d577ddec.png";